const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const formActions = require('react-redux-form').actions;
const PropTypes = require('prop-types');
const optionsActions = require('actions/optionsActions');
const { SearchByCode } = require('components/professionTypes/searchByCode');
const { SearchForProfessionWithHelp } = require('components/professionTypes/searchForProfessionWithHelp');
import { formatText } from 'core/i18n';
const classNames = require('classnames');
const { mustShowCnaeQuestion } = require('utilities/logicByCountry');

class CnaeProfessionFinder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            professionCategory: null,
        };
        this.buildBlock = this.buildBlock.bind(this);
        this.buildBlockPositive = this.buildBlockPositive.bind(this);
        this.buildBlockNegative = this.buildBlockNegative.bind(this);
    }

    buildBlockPositive() {
        const { handleSave, disabled } = this.props;

        return (
            <div>
                <SearchByCode sector={''} category={null} handleSave={handleSave} disabled={disabled} />
            </div>
        );
    }

    buildBlockNegative() {
        const { handleSave, disabled, onFieldChange, onActivityChange } = this.props;

        return (
            <SearchForProfessionWithHelp
                sector={''}
                typeCnaeCno={'01'}
                handleSave={handleSave}
                title={formatText('cnaeOrCno-ProfessionSelectTitleCnae')}
                placeholder={formatText('cnaeOrCno-ProfessionSelectPlaceholderCnae')}
                disabled={disabled}
                onChange={onFieldChange}
                onActivityChange={onActivityChange}
            />
        );
    }

    buildBlock() {
        const { answer } = this.props;
        let block;

        switch (answer) {
            case 'Si':
                block = this.buildBlockPositive();
                break;
            case 'No':
                block = this.buildBlockNegative();
                break;
            default:
                block = null;
                break;
        }

        return block;
    }

    render() {
        const { answer } = this.props;
        return <div className={answer == 'No' ? 'search-for-profession' : ''}>{this.buildBlock()}</div>;
    }
}
module.exports.constructor = CnaeProfessionFinder;
module.exports.CnaeProfessionFinder = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        options: state.options,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
    })
)(CnaeProfessionFinder);

CnaeProfessionFinder.propTypes = {
    sector: PropTypes.string,
};
